import evalPredicate from "./eval-predicate";
/*
  TODO- Consider ability to turn these ON in production
 */
// TODO- console.warn vs console.error vs throw

export function warn(msg, predicate) {
  if (predicate === void 0) {
    predicate = true;
  }

  if (undefined) {
    if (evalPredicate(predicate)) {
      console.warn(msg);
    }
  }
} // TODO- Should debug be able to be turned on in production?

export function debug(msg, predicate) {
  if (predicate === void 0) {
    predicate = true;
  }

  if (evalPredicate(predicate)) {
    console.log(msg);
  }
}
export function error(msg, predicate) {
  if (predicate === void 0) {
    predicate = true;
  }

  if (undefined) {
    if (evalPredicate(predicate)) {
      console.error(msg);
    }
  }
}
export function deprecation(msg, predicate) {
  if (predicate === void 0) {
    predicate = true;
  }

  if (undefined) {
    if (evalPredicate(predicate)) {
      console.warn(msg);
    }
  }
}
export default {
  debug: debug,
  error: error,
  warn: warn,
  deprecation: deprecation
};
//# sourceMappingURL=logger.js.map